import { Typography, FONT_FAMILY, Color, ColorSAP, Loading } from '../../ontego-ui';

import Backdrop from '@mui/material/Backdrop';
import Styled from './BackdropStyles';

const LoginBackdrop = props => {
    const { open } = props

    return (
        <Backdrop
            style={{
                zIndex: 100000,
                background: `rgba(42, 46, 52, 1, 0.65)`,
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden"
            }}
            open={open}
        >
            <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography
                        fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                        size={56}
                        color={ColorSAP.neutral[0]}
                        style={{ marginBottom: 40 }}
                    >
                        {`Welcome!`}
                    </Typography>
                </div>
                <Styled.Loading>
                    <Loading />
                </Styled.Loading>
                <Typography
                    fontFamily={FONT_FAMILY.ROBOTO_REGULAR}
                    size={18}
                    color={ColorSAP.neutral[0]}
                    // style={{ marginBottom: 24 }}
                >
                    {`Loading...`}
                </Typography>
            </div>
        </Backdrop>
    )
}

export default LoginBackdrop